import { render, staticRenderFns } from "./UtcOffsets.vue?vue&type=template&id=d672cdd2&"
import script from "./UtcOffsets.vue?vue&type=script&lang=js&"
export * from "./UtcOffsets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports